import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, func } from 'prop-types';
import ZipcodeText from '../../molecules/ZipcodeText';
import { Container, ChevronRightIcon } from './zip-code-bar.styles';

const ZipcodeBar = _ref => {
  let {
    text,
    defaultText,
    zipcode,
    state,
    city,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["text", "defaultText", "zipcode", "state", "city", "onClick"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    onClick: onClick,
    "data-testid": "container"
  }, props), /*#__PURE__*/React.createElement(ZipcodeText, {
    city: city,
    defaultText: defaultText,
    state: state,
    text: text,
    zipcode: zipcode,
    iconHeight: 18,
    iconWidth: 20
  }), /*#__PURE__*/React.createElement(ChevronRightIcon, null));
};

ZipcodeBar.defaultProps = {
  zipcode: undefined,
  state: undefined,
  city: undefined
};
process.env.NODE_ENV !== "production" ? ZipcodeBar.propTypes = {
  text: string.isRequired,
  defaultText: string.isRequired,
  zipcode: string,
  state: string,
  city: string,
  onClick: func.isRequired
} : void 0;
export default ZipcodeBar;